import { render, staticRenderFns } from "./UsersTableAuthorized.vue?vue&type=template&id=5b075bd5&"
import script from "./UsersTableAuthorized.vue?vue&type=script&lang=js&"
export * from "./UsersTableAuthorized.vue?vue&type=script&lang=js&"
import style0 from "./UsersTableAuthorized.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports